import Checkbox from 'antd/es/checkbox/Checkbox';
import NextDayTermsAndCondition from 'components/pages/dashboard/ParcelOrder/components/orderMethods/components/NextDayTermsAndCondition';
import { FC } from 'react';
import { FaShippingFast } from 'react-icons/fa';

interface props {
  handleChange(): void;
  isSelected: boolean;
  serviceName: string;
  serviceId: number;
  deliveryDay: number | string;
}

const OrderMethodServiceTypeItem: FC<props> = ({ handleChange, serviceName, isSelected, serviceId, deliveryDay }) => {
  return (
    <div className={'w-full rounded-xl p-2 bg-white border cursor-pointer flex items-start gap-2 ' + (isSelected ? 'border-t-primary-color' : '')} onClick={handleChange}>
      <Checkbox checked={isSelected} className='relative' />
      <div className=''>
        <div className='flex'>
          <div className='flex items-center gap-x-2 relative bottom-[2px]'>
            <span className='block font-medium whitespace-nowrap'>سرویس {serviceName}</span>
          </div>
          {/* <div className=''>{service.serviceId == 11 && <span className='block text-xs text-t-primary-color'>(تحویل {service.deliveryDay} روزه) </span>}</div> */}
        </div>
        <div>
          {serviceId == 11 && (
            <div className=''>
              <p className='flex items-center py-1 color-inherit whitespace-nowrap text-t-secondary-color'>
                <FaShippingFast className='ml-1 text-xl ' />
                <span className='text-sm'>تحویل سریع روز بعد</span>
              </p>
              <p className='text-xs max-w-56'>
                <span className='text-t-secondary-text-color '>با انتخاب این سرویس مرسوله در اولویت سورت و ارسال قرار میگیرد</span>
              </p>
              {serviceId == 11 && isSelected && <NextDayTermsAndCondition />}
            </div>
          )}
          {serviceId !== 11 && (
            <div>
              <p className='text-xs max-w-56'>
                <span className='text-t-secondary-text-color '>جمع آوری توسط نزدیک ترین نمایندگی و تحویل در {deliveryDay} روز کاری</span>
              </p>
            </div>
          )}
          {/* {serviceId !== 11 && <span className='block text-sm text-t-primary-color'>تحویل {deliveryDay} روزه</span>} */}
        </div>
      </div>
    </div>
  );
};

export default OrderMethodServiceTypeItem;
